import {
	IDepartmentSettingsState,
	initialDepartmentSettingsState
} from '@app/core/store/state/department-settings.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {
	DepartmentSettingsActions,
	EDepartmentSettingsActions,
} from '@app/core/store/actions/department-settings.actions';
import {ESessionActions, SessionActions} from '@app/core/store/actions/session.actions';
import {EIntegrationsActions, IntegrationsActions} from '@app/core/store/actions/integrations.actions';

export const departmentSettingsReducers = (
	state = initialDepartmentSettingsState,
	action: DepartmentSettingsActions | ErrorActions | SessionActions | IntegrationsActions,
): IDepartmentSettingsState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
				isTenantLoading: false,
			};
		}
		case EDepartmentSettingsActions.GetRoundingRules:
		case EDepartmentSettingsActions.GetIntegrations:
		case EDepartmentSettingsActions.PatchDepartment:
		case EDepartmentSettingsActions.GetDepartment: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EDepartmentSettingsActions.GetDepartmentSuccess: {
			return {
				...state,
				department: action.department,
				isLoading: false,
			};
		}
		case EDepartmentSettingsActions.PatchDepartmentSuccess: {
			return {
				...state,
				department: action.department,
				isLoading: false,
			};
		}
		case EDepartmentSettingsActions.GetTenant:
		case EDepartmentSettingsActions.PatchTenant: {
			return {
				...state,
				isTenantLoading: true,
			};
		}
		case EDepartmentSettingsActions.GetTenantSuccess: {
			return {
				...state,
				tenant: action.tenant,
				isTenantLoading: false,
			};
		}
		case EDepartmentSettingsActions.PatchTenantSuccess: {
			return {
				...state,
				tenant: action.tenant,
				isTenantLoading: false,
			};
		}
		case EDepartmentSettingsActions.SetTenant:
		case ESessionActions.SetTenant: {
			return {
				...state,
				tenant: action.tenant,
			};
		}
		case EDepartmentSettingsActions.SetEditingTenant: {
			return {
				...state,
				editingTenant: action.tenant,
			};
		}
		case EDepartmentSettingsActions.GetIntegrationsSuccess: {
			return {
				...state,
				integrations: action.integrations,
				isLoading: false,
			};
		}
		case EIntegrationsActions.GetQuickPosIntegrationSuccess: {
			return {
				...state,
				quickPosIntegration: action.integration,
			};
		}
		case EIntegrationsActions.PatchQuickPosIntegrationSuccess: {
			return {
				...state,
				quickPosIntegration: action.integration,
			};
		}
		case EDepartmentSettingsActions.GetRoundingRulesSuccess: {
			return {
				...state,
				isLoading: false,
				roundingRules: action.roundingRules,
			};
		}
		case EDepartmentSettingsActions.SetEditingDepartment: {
			return {
				...state,
				editingDepartment: action.department,
			};
		}
		case EDepartmentSettingsActions.SetRoundingRules: {
			return {
				...state,
				roundingRules: action.roundingRules,
			};
		}
		default:
			return state;
	}
};
